"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncValidate = exports.isSyncTransform = void 0;
exports.isSyncTransform = transform => transform.length === 1;
exports.isSyncValidate = validate => validate.length === 1;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJleHBvcnRzIiwiaXNTeW5jVHJhbnNmb3JtIiwidHJhbnNmb3JtIiwibGVuZ3RoIiwiaXNTeW5jVmFsaWRhdGUiLCJ2YWxpZGF0ZSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBb0JhQSxPQUFBLENBQUFDLGVBQWUsR0FDeEJDLFNBQXFDLElBQ0NBLFNBQVMsQ0FBQ0MsTUFBTSxLQUFLLENBQUM7QUFRbkRILE9BQUEsQ0FBQUksY0FBYyxHQUFtQkMsUUFBd0IsSUFDbEVBLFFBQVEsQ0FBQ0YsTUFBTSxLQUFLLENBQUMiLCJpZ25vcmVMaXN0IjpbXX0=